module.exports = __webpack_public_path__ + "static/img/taxi.c871eb2b.webp";